import { useState } from 'react';
import { Star, ChevronRight, Loader2 } from 'lucide-react';
import RatingStars from './RatingStars';
import RatingsOverlay from './RatingsOverlay';
import useRatingData from '../hooks/useRatings';

/**
 * Ratings section button that shows average rating and opens overlay when clicked
 */
export default function RatingsSection({ userId, userName }) {
  const [showRatingsOverlay, setShowRatingsOverlay] = useState(false);
  const { avg, count, loading } = useRatingData(userId);

  return (
    <>
      <button
        type="button"
        onClick={() => setShowRatingsOverlay(true)}
        className="flex w-full items-center justify-between gap-3 rounded-xl border border-border bg-secondary/40 px-4 py-3 text-left transition hover:bg-secondary/60"
      >
        <div className="flex items-center gap-2">
          <span className="text-sm font-semibold text-foreground">Ratings</span>
          {loading && <Loader2 className="h-3 w-3 animate-spin text-muted-foreground" />}
        </div>
        <div className="flex items-center gap-2">
          {count === 0 ? (
            <>
              <div className="flex items-center gap-0.5">
                {[1, 2, 3, 4, 5].map((n) => (
                  <Star key={n} className="h-4 w-4 text-muted-foreground/40" />
                ))}
              </div>
              <span className="text-xs text-muted-foreground">No ratings yet</span>
            </>
          ) : (
            <>
              <RatingStars rating={avg} count={count} />
              <span className="text-xs font-medium text-foreground">{avg.toFixed(1)}</span>
            </>
          )}
          <ChevronRight className="h-4 w-4 text-muted-foreground" />
        </div>
      </button>

      {showRatingsOverlay && <RatingsOverlay userId={userId} userName={userName} onClose={() => setShowRatingsOverlay(false)} />}
    </>
  );
}
